module.exports = __webpack_public_path__ + "static/media/8OLA11.99c680a8.jpg";